module.exports = __webpack_public_path__ + "img/index_2.9da52e49.jpg";